import { useQuery } from "@tanstack/react-query";
import { fetch3 } from "../commonApis/commonApis";
import { setFuelList } from "../features/fuel/fuelSlice";
import { useDispatch } from "react-redux";

const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useFuelListData = (
  page: number,
  limit: number,
  searchFor: string,
  vehicleId?: string
) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["fuelList", page, limit, searchFor, vehicleId], // Unique cache key
    queryFn: async () => {
      const res: ApiResponse = await fetch3(
        `${url}/api/fuel/?page=${page}&limit=${limit}&searchFor=${searchFor}${
          vehicleId ? `&vehicleId=${vehicleId}` : ""
        }`,
        "GET"
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to fetch fuel data");
      }

      dispatch(setFuelList(res.data));
      return res.data ?? [];
    },
    enabled: true,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
